import {useUiConfig} from '../../providers/UiConfigProvider';
import {useMediaQuery} from '../../providers/UiMediaQueryProvider';

export type BottomSheetOverlayType = 'dialog' | 'drawer' | 'popover';

function resolveBottomSheetsEnabled(
  enableBottomSheets:
    | boolean
    | {
        dialog?: boolean;
        drawer?: boolean;
        popover?: boolean;
      }
    | undefined,
  overlayType: BottomSheetOverlayType,
): boolean {
  if (enableBottomSheets === undefined || enableBottomSheets === false) {
    return false;
  }
  if (enableBottomSheets === true) {
    return true;
  }
  return enableBottomSheets[overlayType] === true;
}

/**
 * Returns whether bottom sheets are enabled for the given overlay type and the
 * device is a mobile touch device on a small screen.
 */
export function useShouldDisplayBottomSheet(
  overlayType: BottomSheetOverlayType,
) {
  const {isSmallScreen, isTouch} = useMediaQuery();
  const uiConfig = useUiConfig();
  const enabledBottomSheets = resolveBottomSheetsEnabled(
    uiConfig?.enableBottomSheets,
    overlayType,
  );

  return (isSmallScreen ?? false) && (isTouch ?? false) && enabledBottomSheets;
}
